

































































import _, { Dictionary } from 'lodash'
import Multiselect from 'vue-multiselect'

import {
    PEER_GRANT,
    PEER_REVOKE,
    PERMISSIONS
} from '@/store/share/constants'
import { Vue, Component, Prop } from 'vue-property-decorator'
import { Getter, Action } from 'vuex-class'
import PStorage from '@/util/PStorage'
import { Permission, Grant } from '@/store/share/types'
import { UserWithKey } from '@/types/user'

/**
 * Display a user that has access to the current entry
 */
@Component({ components: { Multiselect }, name: 'share-peer' })
export default class SharePeer extends Vue {
    /**
     * Peer's permission level
     */
    @Getter
    userPermissionLevel!: number

    /**
     * Permissions that the current user can assign other users
     */
    @Getter
    assignablePermissions!: Permission[]

    /**
     * Update permission of a peer
     */
    @Action(PEER_GRANT)
    grantPermission!: (grant: Grant) => Promise<boolean>

    /**
     * Revoke access for a peer
     */
    @Action(PEER_REVOKE)
    revokePermission!: (peer: UserWithKey) => Promise<void>

    /**
     * User object to display
     */
    @Prop({ type: Object, required: true })
    peer!: UserWithKey

    /**
     * Icon displayed next to user name
     */
    get icon(): string {
        return this.peer.icon || 'user-circle'
    }

    /**
     * Peer's permission name
     */
    get permission(): string {
        return this.peer.pivot.permission
    }

    /**
     * All available permissions
     */
    get permissions(): Dictionary<Permission> {
        return PERMISSIONS
    }

    /**
     * Whether the current user can change the permission of the peer
     */
    get canChange(): boolean {
        return this.permission !== 'creator' && this.permissionLevel <= this.userPermissionLevel
    }

    /**
     * The permission definition for the peer
     */
    get value(): Permission {
        return this.permissions[this.permission]
    }

    /**
     * The permission level for the peer
     */
    get permissionLevel(): number {
        return this.value.position
    }

    /**
     * Whether the peer is actually the current user
     */
    get you(): boolean {
        return this.peer.name === PStorage.get('username')
    }

    /**
     * Update the peer's permission
     */
    async update(permission: Permission): Promise<void> {
        await this.grantPermission({
            peer: this.peer,
            permission: permission.name
        })
        this.$success({ text: 'User permission updated' })
    }

    /**
     * Revoke the peer's permissions
     */
    async revoke(): Promise<void> {
        await this.revokePermission(this.peer)
        this.$success({ text: 'User permission revoked' })
    }
}
